module.exports = __webpack_public_path__ + "img/geofisica2_4-3_3072.d3265317.webp";